import assest from "../../json/assest";
import { Box, List, ListItem, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/pages/submit.module.scss";
import { Link, useLocation } from "react-router-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useAppSelector } from "../../hooks/useAppSelector";

const SubmitHeader = () => {
  const { pathname } = useLocation();
  const { submission } = useAppSelector((state) => state.appStateSlice);
  // console.warn("all_submissions", all_submissions);

  const all_submissions = submission?.data?.all_submissions;

  return (
    <>
      <Box className={`${styles.submitHeader} ${styles.innerHeader}`}>
        <List>
          <ListItem className={pathname == "/pending" && styles.active}>
            <Link to="/pending">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img src={assest.pendingIcon} width={22} height={22} alt="" />
                </Box>
                <p>
                  Pending Videos <br /> {all_submissions?.pending}
                </p>
              </Box>
            </Link>
          </ListItem>

          <ListItem className={pathname == "/inquiring" && styles.active}>
            <Link to="/inquiring">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img src={assest.inquiryIcon} width={22} height={22} alt="" />
                </Box>
                <p>
                  Inquiring Videos <br /> {all_submissions?.inquiry}
                </p>
              </Box>
            </Link>
          </ListItem>

          <ListItem className={pathname == "/approved" && styles.active}>
            <Link to="/approved">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img
                    src={assest.allPlatfromIcon}
                    width={22}
                    height={22}
                    alt=""
                  />
                </Box>
                <p>
                  Approved Videos <br /> {all_submissions?.approved}
                </p>
              </Box>
            </Link>
          </ListItem>

          <ListItem className={pathname == "/website" && styles.active}>
            <Link to="/website">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img src={assest.globalIcon} width={22} height={22} alt="" />
                </Box>
                <p>
                  Website Only <br /> {all_submissions?.website_only}
                </p>
              </Box>
            </Link>
          </ListItem>

          <ListItem className={pathname == "/duplications" && styles.active}>
            <Link to="/duplications">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img
                    src={assest.duplicateIcon}
                    width={22}
                    height={22}
                    alt=""
                  />
                </Box>
                <p>
                  Duplicated Videos <br /> {all_submissions?.duplicate_videos}
                </p>
              </Box>
            </Link>
          </ListItem>

          <ListItem className={pathname == "/rejected" && styles.active}>
            <Link to="/rejected">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img
                    src={assest.crossRoundIcon}
                    width={22}
                    height={22}
                    alt=""
                  />
                </Box>
                <p>
                  Rejected Videos <br /> {all_submissions?.rejected}
                </p>
              </Box>
            </Link>
          </ListItem>

          <ListItem className={pathname == "/deleted" && styles.active}>
            <Link to="/deleted">
              <Box className={`${styles.SubmitTabBox} tabBox`}>
                <Box className={`${styles.SubmitTabIcon} tabIcon`}>
                  <img
                    src={assest.deleteBlackIcon}
                    width={22}
                    height={22}
                    alt=""
                  />
                </Box>
                <p>
                  Deleted Videos <br /> {all_submissions?.deleted}
                </p>
              </Box>
            </Link>
          </ListItem>
        </List>
      </Box>
    </>
  );
};

export default SubmitHeader;
